import initializeInfoBarIdsForItem from '../../infoBar/initializeInfoBarIdsForItem';
import type Item from 'owa-service/lib/contract/Item';
import type ItemViewState from '../../store/schema/ItemViewState';

/* eslint-disable-next-line @typescript-eslint/no-unused-vars --
 * See aka.ms/mini-lint-errors
 *	> 'loadedItem' is defined but never used. */
export default function loadItemState(itemId: string, loadedItem: Item): ItemViewState {
    const itemViewState: ItemViewState = {
        itemId: itemId,
        isConversationItemPart: false,
        attachmentWell: null,
        isHeaderExpanded: false,
        isRecipientWellTruncated: false,
        infoBarIds: initializeInfoBarIdsForItem(),
        loadingState: {
            isLoading: false,
            hasLoadFailed: false,
        },
    };
    return itemViewState;
}
